
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formazione/corsi",
      function () {
        return require("private-next-pages/formazione/corsi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/formazione/corsi"])
      });
    }
  